import { DropzoneArea } from 'material-ui-dropzone';

export const Upload = (props) => <DropzoneArea
maxFileSize={30000000}
    dropzoneText={"Arraste e solte seu arquivo aqui"}
    {...props}
/>